import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Vehicle APIs
export const getVehicles = (filters = {}) => {
  const params = {};
  if (filters.make) params.make = filters.make;
  if (filters.minPrice) params.minPrice = filters.minPrice;
  if (filters.maxPrice) params.maxPrice = filters.maxPrice;
  if (filters.sort) params.sort = filters.sort;
  
  return axios.get(`${API_URL}/vehicles`, { params });
};

export const getVehicle = (id) => {
  return axios.get(`${API_URL}/vehicles/${id}`);
};

export const createVehicle = (data) => {
  return axios.post(`${API_URL}/vehicles`, data);
};

export const updateVehicle = (id, data) => {
  return axios.put(`${API_URL}/vehicles/${id}`, data);
};

export const deleteVehicle = (id) => {
  return axios.delete(`${API_URL}/vehicles/${id}`);
};

// Contact APIs
export const submitContact = (data) => {
  return axios.post(`${API_URL}/contact`, data);
};

export const getMessages = () => {
  return axios.get(`${API_URL}/contact/messages`);
};

// Upload APIs
export const uploadImages = (files) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  
  return axios.post(`${API_URL}/upload/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const deleteImage = (filename) => {
  return axios.delete(`${API_URL}/upload/images/${filename}`);
};

// Admin APIs
export const adminLogin = (credentials) => {
  return axios.post(`${API_URL}/admin/login`, credentials);
};
